import { render, staticRenderFns } from "./AnnualReturnsApplications.vue?vue&type=template&id=536f8ba2&scoped=true&"
import script from "./AnnualReturnsApplications.vue?vue&type=script&lang=js&"
export * from "./AnnualReturnsApplications.vue?vue&type=script&lang=js&"
import style0 from "./AnnualReturnsApplications.vue?vue&type=style&index=0&id=536f8ba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536f8ba2",
  null
  
)

export default component.exports